import { cn } from "@/lib/utils";
import { title } from "@/lib/format";

const TONES = {
  synced: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  syncing: "bg-blue-50 text-blue-700 ring-blue-200",
  pending: "bg-blue-50 text-blue-700 ring-blue-200",
  drift_detected: "bg-amber-50 text-amber-700 ring-amber-200",
  failed: "bg-rose-50 text-rose-700 ring-rose-200",
  deleted_remotely: "bg-rose-50 text-rose-700 ring-rose-200",
  disabled: "bg-slate-100 text-slate-600 ring-slate-200",
  not_connected: "bg-slate-100 text-slate-600 ring-slate-200",
};

const LABELS = {
  synced: "SYNCED",
  syncing: "SYNCING",
  pending: "PENDING",
  drift_detected: "DRIFT",
  failed: "FAILED",
  deleted_remotely: "DELETED REMOTELY",
  disabled: "DISABLED",
  not_connected: "NOT CONNECTED",
};

export function SyncBadge({ status = "not_connected", className, testId }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold tracking-wide ring-1 ring-inset",
        TONES[status] || TONES.not_connected,
        className
      )}
    >
      {LABELS[status] || title(status).toUpperCase()}
    </span>
  );
}

export function ModeBadge({ mode = "live", testId }) {
  const live = mode === "live";
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold tracking-wide ring-1 ring-inset",
        live ? "bg-blue-600 text-white ring-blue-700" : "bg-slate-800 text-white ring-slate-900"
      )}
    >
      {live ? "LIVE" : "MOCK"}
    </span>
  );
}

export function ExternalActionBadge({ action, testId }) {
  if (!action) return null;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center rounded-md bg-amber-50 px-2 py-0.5 text-[11px] font-semibold tracking-wide text-amber-800 ring-1 ring-inset ring-amber-200"
      title={action}
    >
      EXTERNAL ACTION REQUIRED
    </span>
  );
}